import { Injectable } from "@angular/core";
import { Observable, catchError, retry } from "rxjs";
import { BaseService } from "./base.service";
import { HttpClient } from "@angular/common/http";
import { MatSnackBar } from "@angular/material/snack-bar";
import { TranslateService } from "@ngx-translate/core";
import { CookieService } from "ngx-cookie-service";
import { DynamicPin } from "../models/dynamicPin";
import { InspectionField } from "../models/inpsectionField";
import { FieldDetail } from "../models/fieldDetail";
import { Farm } from "../models/farm";
// import { FieldHistory } from "../models/fieldHistory";
import { Field } from "../models/field";
import { CropType } from "../models/cropType";
import { Ndvi } from "../models/ndvi";
import { Season } from "../models/season";
import { PriorityGroup } from "../models/priorityGroup";
import { Ranking } from "../models/ranking";

@Injectable({
    providedIn: 'root'
  })
  export class MappingService extends BaseService {

    private API_MAPPING_URL = this.API_BASE_URL + "mapping"; 

    constructor(private httpClient: HttpClient,
        public _snackBar: MatSnackBar,
        public cookieService: CookieService,
        public translate: TranslateService) {
            super()
      }


    ////////////////////////////////////////////////////////////////////////////
    //////////////////                GET                     //////////////////
    ////////////////////////////////////////////////////////////////////////////

    getDynamicPinData(tenantId: number, fieldId: number, lat: number, lng: number): Observable<DynamicPin[]> {
      return this.httpClient.get<DynamicPin[]>(this.API_MAPPING_URL + "/analysis/findForPin?tenantId=" + tenantId + "&fieldId=" + fieldId + "&lat=" + lat + "&lng=" + lng)
        .pipe(
          retry(1),
          catchError(err => {
            this.hasError.next(true);
            this._snackBar.open(this.translate.instant('DATA-SERVICE.DYNAMIC-PINS'), this.translate.instant('SNACKBAR.DISMISS'), {
              duration: 5000,
            });
            this.hasError.next(false);
            return this.errorHandler(err);
          })
        );
    }

    getFieldByLatLng(lat, lng, tenantId): Observable<InspectionField> {
      return this.httpClient.get<InspectionField>(this.API_MAPPING_URL + "/field/findByLatLng?latitude=" + lat + "&longitude=" + lng + "&tenantId=" + tenantId)
        .pipe(
          retry(1),
          catchError(err => {
            this.hasError.next(true);
            this._snackBar.open(this.translate.instant('DATA-SERVICE.FIELD-BY'), this.translate.instant('SNACKBAR.DISMISS'), {
              duration: 5000,
            });
            this.hasError.next(false);
            return this.errorHandler(err);
          })
        );
    }

    getFieldById(fieldId: number): Observable<FieldDetail> {
      return this.httpClient.get<FieldDetail>(this.API_MAPPING_URL + "/field/" + fieldId)
        .pipe(
          retry(1),
          catchError(err => {
            this.hasError.next(true);
            this._snackBar.open(this.translate.instant('DATA-SERVICE.FIELD-ADMIN'), this.translate.instant('SNACKBAR.DISMISS'), {
              duration: 5000,
            });
            this.hasError.next(false);
            return this.errorHandler(err);
          })
        );
    }

    getFarmById(farmId): Observable<Farm> {
      return this.httpClient.get<Farm>(this.API_MAPPING_URL + "/farm/findById?id=" + farmId)
        .pipe(
          retry(1),
          catchError(err => {
            this.hasError.next(true);
            this._snackBar.open(this.translate.instant('DATA-SERVICE.FARM-BY'), this.translate.instant('SNACKBAR.DISMISS'), {
              duration: 5000,
            });
            this.hasError.next(false);
            return this.errorHandler(err);
          })
        );
    }

    // getFieldHistory(fieldId: number): Observable<FieldHistory> {
    //   return this.httpClient.get<FieldHistory>(this.API_MAPPING_URL + "/field/findHistory?fieldId=" + fieldId)
    //     .pipe(
    //       retry(1),
    //       catchError(err => {
    //         this.hasError.next(true);
    //         this._snackBar.open(this.translate.instant('DATA-SERVICE.FIELD-HISTORY'), this.translate.instant('SNACKBAR.DISMISS'), {
    //           duration: 5000,
    //         });
    //         this.hasError.next(false);
    //         return this.errorHandler(err);
    //       })
    //     );
    // }

    getFieldSize(fieldId: number): Observable<Field> {
      return this.httpClient.get<Field>(this.API_MAPPING_URL + "/field/findFieldSize?fieldId=" + fieldId)
        .pipe(
          retry(1),
          catchError(err => {
            this.hasError.next(true);
            this._snackBar.open(this.translate.instant('DATA-SERVICE.FIELD-SIZE'), this.translate.instant('SNACKBAR.DISMISS'), {
              duration: 5000,
            });
            this.hasError.next(false);
            return this.errorHandler(err);
          })
        );
    }

    getCropTypes(): Observable<CropType[]> {
      return this.httpClient.get<CropType[]>(this.API_MAPPING_URL + "/crop/findAllTypes")
        .pipe(
          retry(1),
          catchError(err => {
            this.hasError.next(true);
            this._snackBar.open(this.translate.instant('DATA-SERVICE.CROP-TYPES'), this.translate.instant('SNACKBAR.DISMISS'), {
              duration: 5000,
            });
            this.hasError.next(false);
            return this.errorHandler(err);
          })
        );
    }

    getNdviChart(fieldId: number, fromDate: any, toDate: any): Observable<Ndvi[]> {
      return this.httpClient.get<Ndvi[]>(this.API_MAPPING_URL + "/field/findNdviIndexByDateRange?fieldId=" + fieldId + "&fromDate=" + fromDate + "&toDate=" + toDate)
        .pipe(
          retry(1),
          catchError(err => {
            this.hasError.next(true);
            this._snackBar.open(this.translate.instant('DATA-SERVICE.NDVI-CHART'), this.translate.instant('SNACKBAR.DISMISS'), {
              duration: 5000,
            });
            this.hasError.next(false);
            return this.errorHandler(err);
          })
        );
    }

    getActiveSeasons(tenantId: number): Observable<Season[]> {
      return this.httpClient.get<Season[]>(this.API_MAPPING_URL + "/season/findActiveSeasonsForTenant?tenantId=" + tenantId)
        .pipe(
          catchError(err => {
            this.hasError.next(true);
            this._snackBar.open(this.translate.instant('DATA-SERVICE.ACTIVE-SEASONS'), this.translate.instant('SNACKBAR.DISMISS'), {
              duration: 5000,
            });
            this.hasError.next(false);
            return this.errorHandler(err);
          })
        );
    }

    getPriorityGroups(seasonId: number): Observable<PriorityGroup[]> {
      return this.httpClient.get<PriorityGroup[]>(this.API_MAPPING_URL + "/ndvi/priority/findPriorityGroupsForSeason?seasonId=" + seasonId)
        .pipe(
          catchError(err => {
            this.hasError.next(true);
            this._snackBar.open(this.translate.instant('DATA-SERVICE.PRIORITY-GROUPS'), this.translate.instant('SNACKBAR.DISMISS'), {
              duration: 5000,
            });
            this.hasError.next(false);
            return this.errorHandler(err);
          })
        );
    }

    getRankings(groupId: number, calculationId: number): Observable<Ranking[]> {
      return this.httpClient.get<Ranking[]>(this.API_MAPPING_URL + "/ndvi/priority/findLatestRankingForPriorityGroup?groupId=" + groupId + "&calculationId=" + calculationId)
        .pipe(
          catchError(err => {
            this.hasError.next(true);
            this._snackBar.open(this.translate.instant('DATA-SERVICE.RANKINGS'), this.translate.instant('SNACKBAR.DISMISS'), {
              duration: 5000,
            });
            this.hasError.next(false);
            return this.errorHandler(err);
          })
        );
    }

    getUncalculatedRankings(groupId: number, calculationId: number): Observable<Ranking[]> {
      return this.httpClient.get<Ranking[]>(this.API_MAPPING_URL + "/ndvi/priority/findUncalculatedFields?groupId=" + groupId + "&calculationId=" + calculationId)
        .pipe(
          catchError(err => {
            this.hasError.next(true);
            this._snackBar.open(this.translate.instant('DATA-SERVICE.UNCALCULATED-RANKINGS'), this.translate.instant('SNACKBAR.DISMISS'), {
              duration: 5000,
            });
            this.hasError.next(false);
            return this.errorHandler(err);
          })
        );
    }
  

    ////////////////////////////////////////////////////////////////////////////
    ////////////////////             INSERT                  ///////////////////
    ////////////////////////////////////////////////////////////////////////////

    ////////////////////////////////////////////////////////////////////////////
    ////////////////////             UPDATE                  ///////////////////
    ////////////////////////////////////////////////////////////////////////////

    // updateFieldHistory(fieldHistory: FieldHistory): Observable<any> {
    //   return this.httpClient.post<any>(this.API_MAPPING_URL + "/field/addHistory", fieldHistory)
    //     .pipe(
    //       catchError(err => {
    //         this.hasError.next(true);
    //         this._snackBar.open(this.translate.instant('DATA-SERVICE.UPDATE-FIELD-HISTORY'), this.translate.instant('SNACKBAR.DISMISS'), {
    //           duration: 5000,
    //         });
    //         this.hasError.next(false);
    //         return this.errorHandler(err);
    //       })
    //     );
    // }

    ////////////////////////////////////////////////////////////////////////////
    ////////////////////             DELETE                  ///////////////////
    ////////////////////////////////////////////////////////////////////////////
    
  }  